import { Fragment, isValidElement } from "react"
import type { ReactElement, ReactNode } from "react"

function isOpaqueComponentElement(element: ReactElement): boolean {
  return typeof element.type !== "string" && element.type !== Fragment
}

export function hasRenderableContent(node: unknown): boolean {
  if (typeof node === "string") return node.length > 0
  if (typeof node === "number") return true
  if (Array.isArray(node)) return node.some(hasRenderableContent)
  if (!isValidElement<{ children?: ReactNode }>(node)) return false
  if (isOpaqueComponentElement(node)) return true
  return hasRenderableContent(node.props.children)
}
